module.exports = __webpack_public_path__ + "static/media/star.1b52bd83.svg";